export const normalizeClerkErrorMessage = (error: unknown, fallbackMessage: string): string => {
  if (error instanceof Error && typeof error.message === 'string' && error.message.length > 0) {
    return error.message;
  }
  if (typeof error !== 'object' || error === null || !('errors' in error)) {
    return fallbackMessage;
  }
  const rawErrors = (error as { errors?: Array<{ longMessage?: string; message?: string }> })
    .errors;
  const first = rawErrors?.[0];
  if (!first) return fallbackMessage;
  return first.longMessage ?? first.message ?? fallbackMessage;
};

export const isAlreadySignedInMessage = (message: string): boolean =>
  message.toLowerCase().includes('already signed in');

export const hasClerkErrorCode = (error: unknown, code: string): boolean => {
  if (typeof error !== 'object' || error === null || !('errors' in error)) {
    return false;
  }
  const errors = (error as { errors?: Array<{ code?: string }> }).errors;
  return Array.isArray(errors) && errors.some((entry) => entry.code === code);
};
